import { render, staticRenderFns } from "./TesterInfo.vue?vue&type=template&id=87b54142&scoped=true&"
import script from "./TesterInfo.vue?vue&type=script&lang=js&"
export * from "./TesterInfo.vue?vue&type=script&lang=js&"
import style0 from "./TesterInfo.vue?vue&type=style&index=0&id=87b54142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b54142",
  null
  
)

export default component.exports